module.exports = __webpack_public_path__ + "img/commerce-healthcare-logo.da54a403.png";